import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { SystemSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, SystemsFilterSchema } from "../ea.schema.query";

const base = "system";
const systems = createEndpointBase(base);

export const systemsEndpoints = {
  systemsGet: systems({
    method: "GET",
    path: "",
    request: z.object({ filter: SystemsFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(SystemSchemas["general"]),
    description: "Retrieves a list of system definitions with filtering support.",
  }),
  systemsCount: systems({
    method: "GET",
    path: "count",
    request: z.object({ filter: SystemsFilterSchema.pick({ where: true }).optional() }).optional(),
    response: CountResponseSchema,
    description: "Returns the total number of system definitions matching the filters.",
  }),
  systemsCreate: systems({
    method: "POST",
    path: "",
    request: SystemSchemas["createData"],
    response: z.any(),
    description: "Creates a new system definition.",
  }),
  systemsUpdate: systems({
    method: "PATCH",
    path: ":id",
    request: SystemSchemas["update"],
    response: z.any(),
    description: "Updates an existing system definition.",
  }),
  systemsDelete: systems({
    method: "DELETE",
    path: ":id",
    request: z.object({ id: z.number() }),
    response: z.any(),
    description: "Permanently deletes a system definition.",
  }),
} as const;
